import {
  faClock,
  faCreditCard,
  faMapMarkerAlt,
  faPhoneAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import moment from 'moment-timezone';
import { unserialize } from 'php-serialize';
import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import styled from 'styled-components';
import CONSTANTS from '../../constants';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';
import TimeHelper from '../../helpers/TimeHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CartService from '../../services/CartService';

export default class Info extends Component {
  constructor(props) {
    super(props);
    this.state = { showOpeningHours: false, isNowEnabled: false };
  }

  async componentDidMount() {
    let { _location, outlets } = this.props;
    let orderData = CartService.getOrderData(_location.orderTypes, _location);
    const allowedOrderTypes = this.getAllowedOrderTypes(outlets);
    const order_type_id =
      orderData && orderData.order_type_id
        ? orderData.order_type_id
        : allowedOrderTypes['delivery']
          ? _location.orderTypes.filter((ot) => ot.order_type === 'delivery')[0].id
          : _location.orderTypes[0].id;
    if (_location && order_type_id) {
      const isNowEnabled = await TimeHelper.isNowEnabled(_location, order_type_id);
      this.setState({ isNowEnabled });
    }
  }

  async toggleOpeningHoursModal() {
    await this.setState({ showOpeningHours: !this.state.showOpeningHours });
  }

  renderEventDescription(events, date) {
    if (events && events.length > 0) {
      for (let i = 0; i < events.length; i++) {
        // Check if the event start date is in the future
        if (moment(events[i].event_start_date).isSameOrAfter(moment(), 'day')) {
          if (
            moment(date.format(CONSTANTS.DATES.FORMAT.DB)).isBetween(
              moment(events[i].event_start_date),
              moment(events[i].event_end_date),
              'days',
              true
            )
          ) {
            return (
              events[i].event_name +
              ' - '
            );
          }
        }
      }
    }
    return ''; // Ensure a return value if no events match
  }

  renderEventHolidayDescription(event_holidays, date) {
    if (event_holidays && event_holidays.length > 0) {
      for (let i = 0; i < event_holidays.length; i++) {
        for (let j = 0; j < event_holidays[i].multipleDates.length; j++) {
          if (moment(event_holidays[i].multipleDates[j]).isBefore(moment(), 'day')) {
            continue;
          }
          if (
            moment(date.format(CONSTANTS.DATES.FORMAT.DB)).isSame(
              moment(event_holidays[i].multipleDates[j])
            )
          ) {
            return event_holidays[i].event_name + '(Holiday)';
          }
        }
      }
    }
    return null;
  }

  renderOpeningHours() {
    let { _location } = this.props;
    let dayNumbers = CONSTANTS.DATES.DAY_NUMBERS;
    return dayNumbers.map((weekday) => {
      return (
        <div className="flex-column-space-between" key={weekday}>
          <div className='card-font-color'>{moment().isoWeekday(weekday).format('dddd')}</div>
          <div className='card-font-color'>{this.getOpeningHours(_location.workingHours, _location.SpecialEvents ? _location.SpecialEvents : _location.specialEvents, weekday, CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY, true)}</div>
        </div>
      );
    });
  }

  getOpeningHours(
    workingHours,
    eventWorkingHours,
    weekday,
    orderType = CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY,
    isModal = false
  ) {
    let { _location } = this.props;
    let options = _location ? unserialize(_location.options) : [];
    let events = options && options.opening_hours ? options.opening_hours.events : [];
    let openingType = options && options.opening_hours.opening_type;
    let currentTime = moment();
    if (events && events.length > 0) {
      for (let i = 0; i < events.length; i++) {
        if (
          moment(currentTime.format(CONSTANTS.DATES.FORMAT.DB)).isBetween(
            moment(events[i].event_start_date),
            moment(events[i].event_end_date),
            'days',
            true
          )
        ) {
          workingHours = _.filter(eventWorkingHours, function (item) {
            return item.event_name === events[i].event_name;
          });
        }
      }
    }
    if (!isModal) {
      if (this.state.isNowEnabled) {
        let today = TimeHelper.getLatestWorkingHour(workingHours, weekday, orderType);
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const restaurantTiming = TimeHelper.formatSingleRestaurantTiming(today, userTimezone, orderType, openingType);
        return restaurantTiming
      } else {
        return 'Closed';
      }
    } else {
      let today = TimeHelper.getLatestWorkingHour(workingHours, weekday, orderType);
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const restaurantTiming = TimeHelper.formatRestaurantTiming(today, userTimezone, orderType, openingType);
      return restaurantTiming
    }
  }

  fireBaseEvent(eventName) {
    AnalyticsService.logEvent(eventName, {
      category: CONSTANTS.EVENTS.MENU.GROUP_NAME,
      locationId: this.props._location.slug
    });
    return true;
  }

  getOrderType(order_type_id) {
    if (OrderTypeHelper.isPickup(this.props._location.orderTypes, order_type_id)) {
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.PICK_UP;
    } else if (OrderTypeHelper.isDelivery(this.props._location.orderTypes, order_type_id)) {
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY;
    } else if (OrderTypeHelper.isDineIn(this.props._location.orderTypes, order_type_id)) {
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DINE_IN;
    } else {
      return CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.CURBSIDE_PICKUP;
    }
  }

  getOrderMinimumByType(order_type_id, _location) {
    if (OrderTypeHelper.isPickup(this.props._location.orderTypes, order_type_id)) {
      return OrderTypeHelper.getMinimumOrderFor(
        this.props._location.orderTypes,
        CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.PICK_UP
      );
    } else if (OrderTypeHelper.isDelivery(this.props._location.orderTypes, order_type_id)) {
      if (_location.deliveryAreas.length > 0) {
        let deliveryAreaMin = [];
        for (let i = 0; i < _location.deliveryAreas.length; i++) {
          if (_location.deliveryAreas[i].minimum_order !== '') {
            deliveryAreaMin.push(_location.deliveryAreas[i].minimum_order);
          }
        }
        if (deliveryAreaMin.length > 0) {
          return Math.min(...deliveryAreaMin);
        } else {
          return OrderTypeHelper.getMinimumOrderFor(
            this.props._location.orderTypes,
            CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY
          );
        }
      } else {
        return OrderTypeHelper.getMinimumOrderFor(
          this.props._location.orderTypes,
          CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY
        );
      }
    } else if (OrderTypeHelper.isDineIn(this.props._location.orderTypes, order_type_id)) {
      return OrderTypeHelper.getMinimumOrderFor(
        this.props._location.orderTypes,
        CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DINE_IN
      );
    } else {
      return OrderTypeHelper.getMinimumOrderFor(
        this.props._location.orderTypes,
        CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.CURBSIDE_PICKUP
      );
    }
  }

  getAllowedOrderTypes(outlets) {
    if (!outlets) return {};

    const allowedOrderTypes = {};
    for (let i = 0; i < outlets.length; i++) {
      const out = outlets[i];
      for (let j = 0; j < out.orderTypes.length; j++) {
        allowedOrderTypes[out.orderTypes[j].order_type] = true;
      }
    }
    return allowedOrderTypes;
  }

  getHours(workingHours, weekday) {
    let filterRes = _.filter(workingHours, function (item) {
      return item.parent === weekday;
    });
    if (filterRes.length === 0) {
      filterRes = _.filter(workingHours, function (item) {
        return item.weekday === weekday;
      });
    }
    if (filterRes.length === 0) {
      filterRes = _.filter(workingHours, function (item) {
        return item.weekday !== weekday;
      });
    }
    const groupedSlots = _.groupBy(filterRes, (item) => {
      return [item['opening_time'], item['closing_time']];
    });
    const keys = Object.keys(groupedSlots);
    let hours = [];
    for (let i = 0; i < keys.length; i++) {
      let tempHours = keys[i].split(',');
      let hour = { open: tempHours[0], close: tempHours[1] };
      hours.push(hour);
    }
    return hours;
  }

  render() {
    let { _location, outlets } = this.props;
    let orderData = CartService.getOrderData(_location.orderTypes, _location);
    const allowedOrderTypes = this.getAllowedOrderTypes(outlets);
    const order_type_id =
      orderData && orderData.order_type_id
        ? orderData.order_type_id
        : allowedOrderTypes['delivery']
          ? _location.orderTypes.filter((ot) => ot.order_type === 'delivery')[0].id
          : _location.orderTypes[0].id;
    let minimumOrder = this.getOrderMinimumByType(order_type_id, _location);
    let orderType = this.getOrderType(order_type_id);
    let options = _location ? unserialize(_location.options) : [];
    let events = options && options.opening_hours ? options.opening_hours.events : [];
    let event_holidays =
      options && options.opening_hours ? options.opening_hours.event_holidays : [];
    const current_time = moment(new Date());
    let date = moment(current_time);
    if (this.props.grid_layout !== 'old') {
      return (
        <div className="info-custom ps-1 pe-3">
          <div className={!_location.location_telephone ? 'row row-without-telephone' : 'row'}>
            {!_location.is_master_venue && (
              <div className="address mt-1 col-md-4 col-sm-6 col-lg-5">
                <a
                  className="f4 text-muted text-decoration-none text-normal header-font-1 me-1"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={ViewHelper.getGoogleMapsLink(
                    `${_location.latitude}, ${_location.longitude}`
                  )}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} size={'lg'} color='var(--header-font1-color)' />

                  <span className="ps-2 header-font-1">
                    {/*Awesamosas - CSD Mall Cavalry, Masood Anwari Rd, Cavalry Ground, Lahore, Punjab*/}
                    {_location.formattedAddress}
                  </span>
                </a>
              </div>
            )}

            {_location.location_telephone && (
              <div className="telephone f4 mt-1 col-md-3">
                <a
                  className="f4 text-muted text-decoration-none text-normal header-font-1"
                  href={`tel:${_location.location_telephone}`}
                >
                  <FontAwesomeIcon icon={faPhoneAlt} size={'lg'} color='var(--header-font1-color)' />

                  <span className="ps-2 header-font-1">{_location.location_telephone}</span>
                </a>
              </div>
            )}
            <div
              className={
                !_location.location_telephone
                  ? 'col-md-3 opening-hours opening-hour-without-telephone f4 text-muted text-normal header-font-1'
                  : 'col-md-3 opening-hours f4 text-muted text-normal header-font-1'
              }
              onClick={this.toggleOpeningHoursModal.bind(this)}
            >
              <FontAwesomeIcon icon={faClock} size={'lg'} color='var(--header-font1-color)' />

              {(!events || events.length === 0) && (!event_holidays || event_holidays.length === 0) ? (
                <span className="ps-2 header-font-1">
                  {this.getOpeningHours(
                    _location.workingHours,
                    _location.SpecialEvents ? _location.SpecialEvents : _location.specialEvents,
                    moment().isoWeekday(),
                    orderType
                  )}
                </span>
              ) : (
                <span className="ps-2 header-font-1">
                  {event_holidays && event_holidays.length > 0
                    ? this.renderEventHolidayDescription(event_holidays, date) : this.renderEventDescription(events, date) + this.getOpeningHours(
                      _location.workingHours,
                      _location.SpecialEvents ? _location.SpecialEvents : _location.specialEvents,
                      moment().isoWeekday(),
                      orderType
                    )
                  }
                </span>
              )}
            </div>
            <div className="col-md-3 minimum-order minimum-order-desktop f4 text-muted text-normal header-font-1 d-md-none">
              <FontAwesomeIcon icon={faCreditCard} size={'lg'} color='var(--header-font1-color)' />
              <span className="ps-2 header-font-1">
                {ViewHelper.formatMinimumOrder(
                  minimumOrder,
                  _location.currency,
                  _location.decimal_places
                )}
              </span>
            </div>
            <div className="minimum-order-mobile flex-column-space-between mt-1 d-sm-none d-md-block col-md-3">
              <div className="minimum-order f4 text-muted text-normal header-font-1">
                <FontAwesomeIcon className="restaurant-icon" icon={faCreditCard} size={'lg'} color='var(--header-font1-color)' />
                <span className="ps-2 header-font-1">
                  {ViewHelper.formatMinimumOrder(
                    minimumOrder,
                    _location.currency,
                    _location.decimal_places
                  )}
                </span>
              </div>
            </div>
          </div>
          <StyledOpeningHourModal
            className={'opening-hour-modal'}
            centered
            isOpen={this.state.showOpeningHours}
            toggle={this.toggleOpeningHoursModal.bind(this)}
          >
            <ModalHeader className="primary-color primary-font-color"><span className='text-bold'>Opening Hours</span></ModalHeader>
            <ModalBody className='card-color'>{this.renderOpeningHours()}
              <div className='f4 mt-1'>(* Next day)</div>
            </ModalBody>

          </StyledOpeningHourModal>
        </div>
      );
    } else if (this.props.grid_layout === 'old') {
      return (
        <div className="info-old ps-3 pe-3">
          <div className="f3 text-bold mt-1 mb-1 header-font-1">{_location.category_name}</div>
          {!_location.is_master_venue && (
            <div className="address mt-1">
              <a
                className="f4 text-muted text-decoration-none text-normal"
                rel="noopener noreferrer"
                target="_blank"
                href={ViewHelper.getGoogleMapsLink(`${_location.latitude}, ${_location.longitude}`)}
              >
                <FontAwesomeIcon className="icon-color header-font-1" icon={faMapMarkerAlt} color='var(--header-font1-color)' />
                <span className="ps-2 header-font-1">{_location.formattedAddress}</span>
              </a>
            </div>
          )}

          {_location.location_telephone && (
            <div className="telephone f4 mt-1">
              <a
                className="f4 text-muted text-decoration-none text-normal header-font-1"
                href={`tel:${_location.location_telephone}`}
              >
                <FontAwesomeIcon className="icon-color header-font-1" icon={faPhoneAlt} />
                <span className="ps-2 header-font-1">{_location.location_telephone}</span>
              </a>
            </div>
          )}

          <div className="flex-column-space-between mt-1">
            {(!events || events.length === 0) && (!event_holidays || event_holidays.length === 0) ? (
              <div
                className="opening-hours f4 text-muted text-normal header-font-1"
                onClick={this.toggleOpeningHoursModal.bind(this)}
              >
                <FontAwesomeIcon className="icon-color header-font-1" icon={faClock} />
                <span className="pl-2 timing header-font-1">
                  {this.getOpeningHours(
                    _location.workingHours,
                    _location.SpecialEvents ? _location.SpecialEvents : _location.specialEvents,
                    moment().isoWeekday(),
                    orderType
                  )}
                </span>
              </div>
            ) : (
              <div
                className="opening-hours f4 text-muted text-normal header-font-1"
                onClick={this.toggleOpeningHoursModal.bind(this)}
              >
                <FontAwesomeIcon className="icon-color header-font-1" icon={faClock} />
                <span className="pl-2 header-font-1">
                  {event_holidays && event_holidays.length > 0
                    ? this.renderEventHolidayDescription(event_holidays, date) : this.renderEventDescription(events, date) + this.getOpeningHours(
                      _location.workingHours,
                      _location.SpecialEvents ? _location.SpecialEvents : _location.specialEvents,
                      moment().isoWeekday(),
                      order_type_id,
                      orderType
                    )
                  }
                </span>
              </div>
            )}
            <div className="minimum-order f4 text-muted text-normal header-font-1 d-md-none">
              <FontAwesomeIcon className="icon-color header-font-1" icon={faCreditCard} />
              <span className="pl-2 header-font-1">
                {ViewHelper.formatMinimumOrder(
                  minimumOrder,
                  _location.currency,
                  _location.decimal_places
                )}
              </span>
            </div>
          </div>

          <div className="flex-column-space-between mt-1 d-none d-sm-none d-md-block">
            <div className="minimum-order f4 text-muted text-normal header-font-1">
              <FontAwesomeIcon className="icon-color header-font-1" icon={faCreditCard} />
              <span className="ps-2 header-font-1">
                {ViewHelper.formatMinimumOrder(
                  minimumOrder,
                  _location.currency,
                  _location.decimal_places
                )}
              </span>
            </div>
          </div>
          <Modal
            centered
            isOpen={this.state.showOpeningHours}
            toggle={this.toggleOpeningHoursModal.bind(this)}
          >
            <ModalHeader className="primay-color primary-font-color">Opening Hours</ModalHeader>
            <ModalBody className='card-color p-3'>{this.renderOpeningHours()}</ModalBody>
          </Modal>
        </div>
      );
    }
  }
}

const StyledOpeningHourModal = styled(Modal)`
  .modal-body {
    padding: 15px !important;
  }
`;